import { apiSlice } from "../../app/api/apiSlice";

export const postClosingConditionApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		postClosingCondition: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/loan/get_conditions/${credentials?.loanGuid}/postclosing`,
				method: "GET",
			}),
		}),
	}),
});

export const { usePostClosingConditionMutation } = postClosingConditionApiSlice;
